import React from 'react'
import "./text.scss"
import '../../../styles/fontSizes.scss'

//SizeType puede ser 1, 2, 3, 4...
//type puede ser h -> h1 h2, etc o p -> párrafo
//fontWeight puede ser 100, 200, 300 o 400.
const Text = ({type ,textSize, children, fontWeight, color, className}) =>{
    return(
        <>
            {
                type === "p"?
                <p style ={{fontWeight: fontWeight?fontWeight:"200", color: color}} className = {`text__adjust-default font-size--${textSize} ${className?className:""}`} >{children}</p>
                :
                type === "h"?
                <h4 style ={{fontWeight: fontWeight?fontWeight:"bold", color: color}} className = {`text__adjust-default font-size--${textSize} ${className?className:""}`}>{children}</h4>
                :
                "Creación inválida del componente 'Text'"
            }
        </>
    )
}

export default Text;